import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarService } from 'app/main/pages/calendar/calendar.service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { GetterSetter } from '../helper/project';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DateServiceService } from '../helper/dateservice';

@Component({
  selector: 'app-add-time-sheet',
  templateUrl: './add-time-sheet.component.html',
  styleUrls: ['./add-time-sheet.component.scss']
})
export class AddTimeSheetComponent implements OnInit {

  statusForm: FormGroup
  projectInfo = [];
  viewProjectName: any;
  workStatusShow: boolean;
  tenantId: any;
  profileId: any;
  inTime: any;

  constructor(
    private fb: FormBuilder,
    private parseService: ParseService,
    private calendarService: CalendarService,
    private storageConfiguration: StorageConfiguration,
    private toaster: ToastrService,
    private projectService: GetterSetter,
    public dialog: MatDialogRef<AddTimeSheetComponent>,
    private router: Router,
    private dateService: DateServiceService
  ) {
    this.profileId = this.parseService.instance.User.current() ? this.parseService.instance.User.current().get('profile').id : '';
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.statusForm = this.fb.group({
      inTime: ['', Validators.required],
      project: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.selectProject();
    this.getUserInTime();
  }


  statusClose() {
    this.router.navigate([this.router.url]);
    this.dialog.close();
  }

  async userTimeSheetCreate() {
    // Check Today User Time Sheet Record
    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let userTimeRecord = new this.parseService.instance.Query(UserTimeSheet);
    userTimeRecord.equalTo('profileId', { __type: "Pointer", className: "Profile", objectId: this.profileId });
    let today = new Date();
    let currentDate = this.calendarService.startEndDates(today);
    userTimeRecord.greaterThan('createdAt', currentDate[0]);
    userTimeRecord.lessThan('createdAt', currentDate[1]);
    let result = await userTimeRecord.find();
    let projectName = this.projectInfo.filter(x => x.id == this.statusForm.value.project);

    let logTime = this.statusForm.value.inTime;
    let currentInTime = this.timeConvertToUTC(logTime);

    if (result.length === 0) {
      this.viewProjectName = this.statusForm.value.project;
      this.workStatusShow = false;

      let workTime = [
        {
          project: {
            name: projectName[0].projectName,
            id: this.statusForm.value.project
          },
          inTime: currentInTime,
          outTime: 0,
          actualHours: 0
        },
      ]

      let totalAttendance =
      {
        worktime: 0,
        breaktime: 0,
        project: [
          {
            id: this.statusForm.value.project,
            name: projectName[0].projectName,
            actualHours: 0
          }
        ]
      }

      var userTimeSheet = new UserTimeSheet();
      userTimeSheet.set('workTime', workTime);
      userTimeSheet.set('profileId', { __type: "Pointer", className: "Profile", objectId: this.profileId })
      userTimeSheet.set('tenantId', this.tenantId);
      userTimeSheet.set('isSheetSubmitted', false);
      userTimeSheet.set('currentStatus', 'work');
      userTimeSheet.set('user', { __type: "Pointer", className: "_User", objectId: this.parseService.instance.User.current().id });
      userTimeSheet.set('breakTime', []);
      userTimeSheet.set('totalAttendance', totalAttendance);
      userTimeSheet.set('inTime', currentInTime);
      userTimeSheet.set('isClosed', false);
      userTimeSheet.set('outTime', 0);
      userTimeSheet.set('updateTime', currentInTime);
      userTimeSheet.set('agreedStartTime', this.inTime);
      userTimeSheet.set('isUpdated', false);
      userTimeSheet.set('version', '1.0.0');
      userTimeSheet.save().then(async (res) => {
        this.toaster.success('In Time Updated Successfully!!');
        this.dialog.close();
        this.projectService.sendMessage("TimeSheetRecord");
        this.storageConfiguration.sessionSetItem(this.storageConfiguration.projectId, this.statusForm.value.project);
      });
    }
    else {
      this.toaster.warning('Already In-Time Updated!!');
      this.dialog.close();
    }
  }

  selectProject() {
    let userId = this.parseService.instance.User.current().id;
    let ProjectMembers = this.parseService.instance.Object.extend("ProjectMembers");
    let projectMembers = new this.parseService.instance.Query(ProjectMembers);

    projectMembers.equalTo("user", {
      __type: "Pointer",
      className: "_User",
      objectId: userId,
    });

    projectMembers.include("project");
    projectMembers.find().then((result) => {
      for (let project of result) {
        let projectId = project.get("project").id;
        let role = project.get("role");
        let projectName = project.get("project").get("projectInfo").projectName;
        this.projectInfo.push({
          id: projectId,
          role: role,
          projectName: projectName,
        });
      }
      let defaultProject = this.projectInfo.filter(x => x.projectName == "Unassigned Project");
      this.statusForm.get('project').setValue(defaultProject[0].id);
      let todayDate = new Date();
      this.statusForm.get('inTime').setValue(`${todayDate.getHours()}:${todayDate.getMinutes()}`);
    });
  }

  timeConvertToUTC(logTime: string) {
    let today = new Date();
    const [hours, minutes] = logTime.split(':');
    const [minute] = minutes.split(' ');
    let currentInTime = Number(today.setHours(Number(hours), Number(minute)));
    return currentInTime;
  }

  async getUserInTime() {
    let Profile = this.parseService.instance.Object.extend('Profile');
    let profile = new this.parseService.instance.Query(Profile);
    profile.equalTo('objectId', this.profileId)
    let profileDetails = await profile.find();
    this.inTime = profileDetails[0].get('officialInfo').startTime;
  }

}
